import React, { useState, useEffect, useMemo } from 'react'
import { formatDate } from 'formatters'
import { makeStyles } from '@material-ui/core/styles'
import { Button, Loader, Table, Typography } from 'foundations-library/components'
import { IEnrollmentEvent, IEnrollmentEventCollection, EnrollmentEventsContext } from '../contexts/EnrollmentEventsContext'

const useStyles = makeStyles((theme) => ({
    mb15: {
        marginBottom: 15
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center'
    }
}))

type PropsType = {
    entityType: 'brand' | 'campaign',
    entityId: string,
    viewHeight: number,
    breakPoints: {
        belowXS: boolean,
        belowSM: boolean
    }
}

const getTableRowData = (item) => [formatDate(item.createdAt), item.eventName, item.description]
/**
 *
 */
const EnrollmentEvents = (props: PropsType): JSX.Element => {
    const classess = useStyles()
    const [seeMore, setSeeMore] = useState(false)
    const eventsContext = React.useContext(EnrollmentEventsContext)
    const [eventList, setEventList] = useState([] as IEnrollmentEvent[])
    const [loading, setLoading] = useState(false)

    const list = async () => {
        setLoading(true)
        const res = (await eventsContext.list(props.entityType, props.entityId)) as IEnrollmentEventCollection
        eventList.push(...res.events)
        setEventList(eventList)
        setLoading(false)
    }
    // load initial data on mount
    useEffect(() => {
        list()
    }, [])

    const rows = useMemo(() => {
        if (!eventList.length) return []
        if (seeMore) {
            return eventList.map((item) => getTableRowData(item))
        }

        return [getTableRowData(eventList[0])]
    }, [seeMore, eventList.length])

    if (loading) return <Loader inlineBlock />
    return <div data-testid='enrollment-events'>
        {
            rows.length
                ? <Table
                    columns={['Date', 'Event', 'Description']}
                    rows={rows}
                    className={classess.mb15}
                    scrollAfterRow={10}
                    data-testid='events-table'
                />
                : <Typography
                    variant='subtitle2'
                    align='center'
                    data-testid='enrollment-events-no-items'
                >No events found.</Typography>
        }
        {
            eventList.length > 1
                ? <div className={classess.buttonContainer}>
                    <Button
                        variant='outlined'
                        onClick={() => setSeeMore((prev) => !prev)}
                        data-testid='enrollment-events-see-more-btn'
                    >
                        {seeMore ? 'See less' : 'See more'}
                    </Button>
                </div>
                : null

        }
    </div>
}

/**
 *
 */
export default EnrollmentEvents
